import React, {useState} from 'react';
import './toggle-switch-button.scss'
import PropTypes from "prop-types";

/**
 * Reusable Toggle switch component with 'Yes' and 'No' options.
 *
 * @param {boolean} isChecked
 * @param {function} onChangeHandler
 * @param {string} extraClasses
 * @returns {JSX.Element}
 *
 * @author Ahsan Ejaz <ahsan@250mils.com>
 */
const ToggleSwitchButton = ({isChecked = false, onChangeHandler = $.noop, extraClasses = ''}) => {

    const [isToggleOn, setToggleOn] = useState(isChecked);

    const handleChange = (e) => {
        let isOn = e.target.getAttribute("data-value") === '1'
        setToggleOn(isOn);
        onChangeHandler(isOn)
    }

    return (
        <div className={`toggle-switch-btn ${extraClasses}`}>
            <span data-value={'1'} className={`toggle-option content-body -left body-md-regular ${isToggleOn ? 'selected' : ''}`} onClick={handleChange}>{i18next.t('pmwjs_yes')}</span>
            <span data-value={'0'} className={`toggle-option content-body -right ${!isToggleOn ? 'selected' : ''}`} onClick={handleChange}>{i18next.t('pmwjs_no')}</span>
        </div>
    )

}
ToggleSwitchButton.propTypes = {

    /**
     * To select the Yes option by default
     */
    isChecked: PropTypes.bool,
    /**
     * Optional handler function
     */
    onChangeHandler: PropTypes.func,
    /**
     * Any extra classes for the pop
     */
    extraClasses: PropTypes.string
}

export default ToggleSwitchButton;